module.exports = __webpack_public_path__ + "static/media/fondovi-footer.8e74c1e4.png";